import React, { useEffect, useState } from "react";
import {
  IonRadioGroup,
  IonRadio,
  IonLabel,
  IonItem,
  IonListHeader,
} from "@ionic/react";

interface QuestionData {
    sentence: string;
    correctAnswer: string;
    options: string[]; // Type of noun: Concrete or Abstract
}


const UnderlineGerundPhraseWorksheet: React.FC = () => {
  // Define dynamic questions with options

    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [questions, setQuestions] = useState<QuestionData[]>([]);

    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };

    const handleSubmit = (option: React.SetStateAction<string | null>) => {
        setSelectedOption(option);
        const currentQuestion = questions[currentIndex];
        if (option === currentQuestion.correctAnswer) {
            // Automatically move to the next question
            setShowImage(true);
            setTimeout(() => {
                const nextIndex = currentIndex + 1;
                if (nextIndex < questions.length) {    
                    setCurrentIndex(nextIndex);
                    setShowImage(false);
                }
                else {
                    setCurrentIndex(0);
                    fetchQuestions();
                }
            }, 5000); // Delay reduced to 3 seconds
        }
    };

    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'FindGerunds.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/FindGerunds.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };

    useEffect(() => {
        fetchQuestions();
    }, []);

    return (
    <>
        {showImage === false ? (
            <>
                <div className="contentPart showCenter fillPreposition additionWord">
                <h2>
                    <strong>Question :</strong>{" "}
                    {questions[currentIndex]?.sentence}
                </h2>
              <IonRadioGroup
                value={selectedOption}
                onIonChange={(e) => handleSubmit(e.detail.value)}
              >
                <IonListHeader>
                  <h5>Select the gerund phrase:</h5>
                </IonListHeader>
                {questions[currentIndex]?.options.map((option, index) => (
                    <IonItem
                    className={` ${
                        selectedOption === option
                        ? option === questions[currentIndex]?.correctAnswer
                            ? "correct"
                            : "errorItems"
                        : ""
                    }`}
                        key={index}>
                    <IonRadio slot="start" value={option} />
                    <IonLabel>{option}</IonLabel>
                  </IonItem>
                ))}
                              </IonRadioGroup>
                </div>
                </>
                ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: "150px" }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                        />
                    </div>
                </>
            )}
        </>
  );
};

export default UnderlineGerundPhraseWorksheet;
